package nl.astraeus.wiki.messages

class UpdateWikiOrderMessage() : Message(
  MessageType.UPDATE_WIKI_ORDER,
  MessageHeader.WIKI_IDS,
) {

  constructor(msg: String) : this() {
    message = msg
    checkType(MessageType.UPDATE_WIKI_ORDER)
  }

  constructor(wikiIds: List<Long>) : this() {
    setHeader(MessageHeader.WIKI_IDS, wikiIds.joinToString(","))
  }
}
